<template>
  <g>
    <g transform="scale(0.65)">
      <text transform="matrix(1 0 0 1 160 50)" class="name">딥스위치{{number}}</text>
      <path class="st0" d="M156,290V67c0-4.42,3.58-8,8-8h129c4.42,0,8,3.58,8,8v223c0,4.42-3.58,8-8,8H164C159.58,298,156,294.42,156,290z"/>
      <path class="st1" d="M298,289V67c0-2.76-2.24-5-5-5H164c-2.76,0-5,2.24-5,5v222c0,2.76,2.24,5,5,5h129
          C295.76,294,298,291.76,298,289z"/>
      <rect @click="switchOnOff" x="223.72" y="128" class="st2" width="40" height="97" />
      <rect @click="switchOnOff" id="dip-onoff" x="223.72" y="185" class="st3" width="40" height="40"/>
      <g>
        <text transform="matrix(1 0 0 1 170 120)" class="label">ON</text>
        <text transform="matrix(1 0 0 1 170 250)" class="label">OFF</text>
      </g>
      <g class="pin">
          <rect x="234.44" y="87.51" width="18.57" height="18.57"/>
          <path class="st4" d="M255.07,108.14h-22.69V85.44h22.69V108.14z M236.5,104.01h14.44V89.57H236.5V104.01z"/>
          <rect :id="`${pincode}MS`" @click="onClick(`${pincode}MS`)" class="pin-cover terminal" x="232" y="84.51" width="20" height="20"/>
      </g>
      <g class="pin">
          <rect x="234.44" y="250.51" width="18.57" height="18.57"/>
          <path class="st4" d="M255.07,271.14h-22.69v-22.69h22.69V271.14z M236.5,267.01h14.44v-14.44H236.5V267.01z"/>
          <rect :id="`${pincode}PS`" @click="onClick(`${pincode}PS`)" class="pin-cover terminal" x="232" y="247.51" width="25" height="25"/>
      </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      on: false,
      mode: 'off',
      timeline: null,
      socket: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    switchOnOff (e) {
      if (this.on) {
        window.event.stopPropagation()
        if (this.mode === 'off') {
          this.mode = 'on'
          this.timeline = new window.TimelineMax({ repeat: 0 })
          this.timeline.to(`#${this.data.id} #dip-onoff`, 0.5, { y: -56 })
          store.commit('socket/sendMessage', { socket: this.socket, message: { value: 1 } })
          // this.socket.send
        } else {
          this.mode = 'off'
          this.timeline = new window.TimelineMax({ repeat: 0 })
          this.timeline.to(`#${this.data.id} #dip-onoff`, 0.5, { y: 7 })
          store.commit('socket/sendMessage', { socket: this.socket, message: { value: 0 } })
        }
      } else {
        this.on = true // for test
      }
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.mode = 'off'
      this.timeline = new window.TimelineMax({ repeat: 0 })
      this.timeline.to(`#${this.data.id} #dip-onoff`, 0.5, { y: 7 })

      store.commit('socket/sendMessage', { socket: this.socket, message: { value: 0 } })
    },
    off () {
      this.on = false
      this.socket = null
      this.mode = 'off'
      this.timeline = new window.TimelineMax({ repeat: 0 })
      this.timeline.to(`#${this.data.id} #dip-onoff`, 0.5, { y: 7 })
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin-name{
  display: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
  }
  .pin-name{
    display: block;
    font-size: 22px;
  }
}
.selected{
  & path.st0 {
    display: block;
    fill: #ff6f61;
  }
}
.name{font-size: 22px}
.label{stroke:#F5BD41; fill:#F5BD41; font-size: 28px;}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:#1F1A16;}
.st2{fill:#4F4439;}
.st3{fill:#F5BD41;}
.st4{fill:#514E55;}
</style>
